import { Marker, useMapEvents } from "react-leaflet";
import { redIcon } from "../../../utils/leafletIcons";

interface LocationPickerProps {
  location: { lat: number; lng: number; name: string } | null;
  setLocation: (loc: { lat: number; lng: number; name: string } | null) => void;
}

const LocationPicker: React.FC<LocationPickerProps> = ({
  location,
  setLocation,
}) => {
  useMapEvents({
    click(e: any) {
      setLocation({ lat: e.latlng.lat, lng: e.latlng.lng, name: "" });
    },
  });

  return location ? (
    <Marker position={[location.lat, location.lng]} icon={redIcon} />
  ) : null;
};

export default LocationPicker;
